export enum ApplicationPropertyEnum {
    FirstName = 1,
    LastName = 2,
    DateOfBirth = 3,
    School = 4,
    Email = 5,
    Grade = 6,
    Address = 7,
    City = 8,
    State = 9,
    ZipCode = 10,
    Gender = 11,
    Ethnicity = 12,
    PhoneNumber = 13,
    Race = 14,
    FosterCare = 15,
    Homeless = 16,
    Parent1FirstName = 17,
    Parent1LastName = 18,
    Parent1Relationship = 19,
    Parent1CellPhoneNumber = 20,
    Parent1Email = 21,
    Parent1Address = 22,
    Parent1City = 23,
    Parent1State = 24,
    Parent1ZipCode = 25,
    Parent1AddressSameAsStudent= 26,
    Parent2FirstName = 27,
    Parent2LastName = 28,
    Parent2Relationship = 29,
    Parent2CellPhoneNumber = 30,
    Parent2Email = 31,
    Parent2Address = 32,
    Parent2City = 33,
    Parent2State = 34,
    Parent2ZipCode = 35,
    Parent2AddressSameAsStudent = 36,
    Parent1HomePhoneNumber = 37,
    Parent2HomePhoneNumber = 38,
    FirstGeneration = 39,
    GraduationYear = 40,
    CustomStudentProperty = 41,
    Parent1HighestEducation = 42,
    Parent2HighestEducation = 43,
    StudentId = 44
}